import LTR from "@brand-icons/global/ui-article/ui-article-ltr.svg";
import RTL from "@brand-icons/global/ui-article/ui-article-rtl.svg";

import { iconFactory } from "../iconFactory";

export const UiArticleIcon = iconFactory("UiArticleIcon", LTR, RTL);
